/**
 * A list of HTML tags that can used by the text elements
 **/

const TextTags = ["div", "h1", "h2", "h3", "nav", "p"];

export default TextTags;
export const TAG_DIV = "div";
